<template>
  <b-dropdown
    :mobile-modal="false"
    style="cursor:pointer"
    position="is-bottom-left"
    append-to-body
    aria-role="menu"
  >
    <b-icon slot="trigger" icon="ellipsis-h"></b-icon>
    <b-dropdown-item @click="qrcode(evenement.shortcut)">
      <img src="@/assets/img/icons/qrcode.png" class="icon" alt="icon-qrcode" />
      {{ $t("public.qrcode") }}
    </b-dropdown-item>
    <b-dropdown-item @click="popupParameters(evenement.id)">
      <img
        src="@/assets/img/icons/parameters.png"
        class="icon"
        alt="icon-reset"
      />
      {{ $t("evenement.configurer") }}
    </b-dropdown-item>
    <b-dropdown-item @click="animer(evenement.shortcut_moderateur)">
      <img
        src="@/assets/img/icons/play-icon.jpg"
        class="icon"
        alt="icon-animate"
      />
      {{ $t("evenement.animer") }}
    </b-dropdown-item>
    <b-dropdown-item @click="shares(evenement.id)">
      <img src="@/assets/img/icons/share.png" class="icon" alt="icon-share" />
      {{ $t("evenement.shares") }}
    </b-dropdown-item>
    <b-dropdown-item @click="duplicate(evenement)">
      <img
        src="@/assets/img/icons/duplicate.png"
        class="icon"
        alt="icon-duplicate"
      />
      {{ $t("evenement.duplicate") }}
    </b-dropdown-item>

    <b-dropdown-item @click="deleteEvenement(evenement.id)">
      <img src="@/assets/img/icons/delete.png" class="icon" alt="icon-delete" />
      {{ $t("common.supprimer") }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "ParametersDropdown",
  props: {
    evenement: Object,
    cardIndex: Number
  },
  methods: {
    popupParameters(idEvenement) {
      this.$store.dispatch("getEvenement", idEvenement);
      this.$store.dispatch("popupToggle");
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        cardList: false,
        parameters: true,
        searchBar: !!this.$store.state.evenement.search_query.length
      });
    },

    sendMessageToParent(taskToDo) {
      let message = {
        task: taskToDo
      };
      window.top.postMessage(message, "*");
    },
    qrcode(evenementUrlClient) {
      var url = "";
      if (this.$store.getters.iframeColidee) {
        url =
          process.env.URL_COLIDEE +
          "o" +
          this.$store.state.authentification.idEntreprise +
          "p" +
          this.$store.state.authentification.idPlateforme +
          "/textit/" +
          evenementUrlClient;
      } else {
        url = process.env.URL_SHORTCUT + "/" + evenementUrlClient + ".htm";
      }
      this.$store.commit("MODAL_QRCODE", {
        urlQrCode: url,
        activeModalQrCode: true,
        codeParticipant: evenementUrlClient
      });
      this.sendMessageToParent("scrollToTop");
    },
    animer(url_moderateur) {
      window.open("/moderateur/" + url_moderateur + ".htm", "_blank");
    },
    shares(evenementId) {
      this.$store.commit("MODAL_SHARES", {
        evenementId: evenementId,
        activeModalShares: true
      });
      this.sendMessageToParent("scrollToTop");
    },
    duplicate(evenement) {
      this.$store.commit("MODAL_DUPLICATE", {
        evenement: evenement,
        activeModalDuplicate: true
      });
      this.sendMessageToParent("scrollToTop");
    },

    deleteEvenement(idEvenement) {
      this.sendMessageToParent("scrollToTop");
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t("evenement.non"),
        confirmText: this.$i18n.t("evenement.oui"),
        message: this.$i18n.t("evenement.confirmer"),
        onConfirm: () => this.$store.dispatch("delete_evenement", idEvenement)
      });
    }
  }
};
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/event/components/ParametersDropdown.vue